export const DataTransferAction = Object.freeze({
  move: 'move',
  insert: 'insert',
})

export class DataTransferPayload {
  constructor(action, value) {
    this.action = action
    this.value = value
  }
}

export default class DataTransfer {
  constructor(value, action = DataTransferAction.insert) {
    this.action = action
    this.value = value
  }

  get data() {
    const data = new DataTransferPayload(this.action, this.value)
    return JSON.stringify(data)
  }

  static parseData(data) {
    try {
      const parsed = this.tryJSONParse(data)
      if (!parsed) {
        return undefined
      }
      const { action, value } = parsed
      return new DataTransferPayload(action, value)
    } catch (error) {
      console.error(error)
    }
  }

  static tryJSONParse(data) {
    try {
      if (data === null) {
        return null
      }
      return JSON.parse(data)
    } catch (error) {
      console.error(error)
      return null
    }
  }
}
